/**
 * @module app.cm
 */

import { autoinject } from 'aurelia-framework';
import { RouteConfig, NavigationInstruction } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { CaseService } from 'app/cm/services/case-service';
import { IContactLogConfig } from 'app/core/models/essette-interfaces';
import * as CM from 'app/cm/models/essette-api';
import * as CD from 'app/cd/models/essette-api';


export interface ICaseContactLogModelData {
    caseId: string;
    readonly?: boolean;
}

@autoinject()
export class ContactLogPage extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    protected caseId: string | null = null;
    protected case: CM.Case | null = null;
    protected member?: CD.Member | null = null;

    protected contactLogConfig?: IContactLogConfig;


    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly caseService: CaseService,
        private readonly i18n: I18N,
        ...rest: any[]) {
        super(...rest);
    }

    protected async canActivate(params: any, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<boolean> {
        await this.accountContext.load();
        return this.accountContext.hasRouteAccess('cm.case.contact-log');
    }

    protected async activate(params: { caseId: string }, routeConfig: RouteConfig, navInstruction: NavigationInstruction): Promise<void> {
        if(!params?.caseId) {
            throw new Error('Missing required parameters: caseId');
        }

        this.caseId = params.caseId;

        await this.reload();

        this.member = this.case?.member;

        if(this.member && routeConfig?.navModel) {
            const title = this.i18n.tr('cd:routes.contactLog.$title', { display: this.member?.$display });
            routeConfig.navModel.setTitle(title);
        }

        this.contactLogConfig = {
            serviceRootUrl: 'cm/cases',
            targetType: 'CM.Case',
            moduleCode: 'CM',
            rollupConfig: {
                serviceRootUrl: 'cd/members',
                targetType: 'CD.Member'
            }
        };
    }

    ////****************** Events ***************************************************////
    protected async reload(): Promise<void> {
        if(this.caseId) {
            await this.loadCase(this.caseId);
        }
    }


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadCase(caseId: string): Promise<void> {
        if(!caseId) return;

        const includes: string[] = [
            'member'
        ];

        try {
            this.state.beginLoad();

            const response = await this.caseService.loadCase(caseId, includes);
            this.case = response.results[0];
        }
        catch(error) {
            throw error;
        }
        finally {
            this.state.endLoad();
        }
    }
}
